import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-testimonials").forEach((el) => {
  const container = el.querySelector(".swiper");
  const sliderPagination = el.querySelector(".slider-pagination");

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, EffectFade, Pagination],
    autoplay: {
      delay: 5000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
    pagination: {
      el: sliderPagination,
      clickable: true,
    },
    simulateTouch: false,
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
